import store from "../store";

export const SnackBarModule = (message, type) => {
  store.commit("showSnackbar", { message, type });
};